/**
 * Illustration décorative de l'accueil : un appareil envoie un fichier à un autre, en
 * direct. Purement ornemental (`aria-hidden`) — tout ce qu'elle montre (connexion directe,
 * pair à pair) est déjà dit en texte ailleurs sur la page (accroche, mode d'emploi).
 */

import { Folder, FileText, Image, PlayCircle } from 'react-feather';
import { useT } from '../i18n/index.js';

function Laptop(): React.JSX.Element {
  return (
    <div className="illu-device illu-laptop">
      <svg viewBox="0 0 140 104" width="140" height="104" aria-hidden="true">
        <rect x="10" y="6" width="120" height="76" rx="3" fill="currentColor" />
        <rect x="19" y="15" width="102" height="58" fill="var(--lime)" />
        <path d="M0 90 H140 L126 102 H14 Z" fill="currentColor" />
      </svg>
      <span className="illu-screen-icon illu-screen-icon-laptop">
        <Image size={26} strokeWidth={2} />
      </span>
    </div>
  );
}

function Phone(): React.JSX.Element {
  return (
    <div className="illu-device illu-phone">
      <svg viewBox="0 0 70 132" width="70" height="132" aria-hidden="true">
        <rect x="3" y="3" width="64" height="126" rx="11" fill="currentColor" />
        <rect x="10" y="16" width="50" height="100" fill="var(--lime)" />
      </svg>
      <span className="illu-screen-icon illu-screen-icon-phone">
        <Image size={20} strokeWidth={2} />
      </span>
    </div>
  );
}

export function HeroIllustration(): React.JSX.Element {
  const translator = useT();

  return (
    <div className="hero-illustration" aria-hidden="true">
      <svg className="illu-arc" viewBox="0 0 400 220" preserveAspectRatio="none" aria-hidden="true">
        <path
          d="M40 190 C 90 40, 310 40, 360 190"
          fill="none"
          stroke="var(--lime-strong)"
          strokeWidth="3"
          strokeDasharray="2 14"
          strokeLinecap="round"
        />
      </svg>

      <span className="illu-float illu-float-1">
        <Image size={20} strokeWidth={2} />
      </span>
      <span className="illu-float illu-float-2">
        <FileText size={20} strokeWidth={2} />
      </span>
      <span className="illu-float illu-float-3">
        <PlayCircle size={20} strokeWidth={2} />
      </span>
      <span className="illu-float illu-float-4">
        <Folder size={20} strokeWidth={2} />
      </span>

      <div className="illu-devices">
        <div className="illu-device-col">
          <Laptop />
          <span className="illu-caption">{translator.t('home.deviceSender')}</span>
        </div>
        <div className="illu-device-col illu-device-col-receiver">
          <Phone />
          <span className="illu-caption">{translator.t('home.deviceReceiver')}</span>
        </div>
      </div>
    </div>
  );
}
